import type { ResponseGetPenetapanPredikatKinerjaStep } from 'types/kinerja-pelaksanaan'

export const dummyPenetapanPredikatKinerjaStep: ResponseGetPenetapanPredikatKinerjaStep =
  {
    data: {
      submissionStep: 'NOT_CREATED',
    },
    meta: {},
  }
